import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/others',
    name: 'others',
    component: () => import('@/views/restricted/others/OthersLayoutView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: [
        'ADMIN_DISTRIBUTOR_NETWORK_CREATE_PERMISSION',
        'ADMIN_DISTRIBUTOR_NETWORK_READ_PERMISSION',
        'ADMIN_CHECK_CLOUD_STORAGE_INTEGRITY',
        'ADMIN_CREATE_NOTIFICATION',
        'ADMIN_ITECH_MANUAL_UPDATE'
      ],
      menuSelected: 'others'
    }
  }
]
